"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "catania": {
    "2681a5b4": [{
      "hkey": "4a123ae9",
      "slug": "librino-san-giorgio",
      "name": "Librino, San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "278421e7": [{
      "hkey": "c30088b9",
      "slug": "cannizzaro-ognina-lungomare-teseo",
      "name": "Cannizzaro, Ognina-Lungomare, Teseo",
      "primary": false,
      "skipSearch": false
    }],
    "389e1af4": [{
      "hkey": "01c9a0d6",
      "slug": "borgo-corso-province-viale-veneto",
      "name": "Borgo, Corso Province-Viale Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "4ef81295": [{
      "hkey": "c30088b9",
      "slug": "cannizzaro-ognina-lungomare-teseo",
      "name": "Cannizzaro, Ognina-Lungomare, Teseo",
      "primary": true,
      "skipSearch": false
    }],
    "5045b58b": [{
      "hkey": "2d8b5f5f",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "5a62c24d": [{
      "hkey": "c30088b9",
      "slug": "cannizzaro-ognina-lungomare-teseo",
      "name": "Cannizzaro, Ognina-Lungomare, Teseo",
      "primary": true,
      "skipSearch": false
    }],
    "8493703c": [{
      "hkey": "df825c52",
      "slug": "rapisardi-san-leone-corso-indipendenza",
      "name": "Rapisardi, San Leone, Corso Indipendenza",
      "primary": true,
      "skipSearch": false
    }],
    "915d66ef": [{
      "hkey": "01c9a0d6",
      "slug": "borgo-corso-province-viale-veneto",
      "name": "Borgo, Corso Province-Viale Veneto",
      "primary": true,
      "skipSearch": false
    }],
    "a0006527": [{
      "hkey": "9df6cb01",
      "slug": "picanello",
      "name": "Picanello",
      "primary": true,
      "skipSearch": false
    }],
    "a0698b9e": [{
      "hkey": "f7f48380",
      "slug": "cannizzaro",
      "name": "Cannizzaro",
      "primary": true,
      "skipSearch": false
    }],
    "a966e0e0": [{
      "hkey": "df825c52",
      "slug": "rapisardi-san-leone-corso-indipendenza",
      "name": "Rapisardi, San Leone, Corso Indipendenza",
      "primary": true,
      "skipSearch": false
    }],
    "b9d85821": [{
      "hkey": "64c2062e",
      "slug": "cibali-san-nullo-trappeto",
      "name": "Cibali, San Nullo, Trappeto",
      "primary": true,
      "skipSearch": false
    }],
    "bd4591a4": [{
      "hkey": "2d8b5f5f",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "canizzano-ognina-lungomare-teseo": [{
      "hkey": "c30088b9",
      "slug": "cannizzaro-ognina-lungomare-teseo",
      "name": "Cannizzaro, Ognina-Lungomare, Teseo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "canizzaro": [{
      "hkey": "f7f48380",
      "slug": "cannizzaro",
      "name": "Cannizzaro",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "c-so-italia-via-leopardi": [{
      "hkey": "01c9a0d6",
      "slug": "borgo-corso-province-viale-veneto",
      "name": "Borgo, Corso Province-Viale Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d80993e3": [{
      "hkey": "17a4f1d8",
      "slug": "barriera-canalicchio",
      "name": "Barriera, Canalicchio",
      "primary": true,
      "skipSearch": false
    }],
    "d859f8bc": [{
      "hkey": "df825c52",
      "slug": "rapisardi-san-leone-corso-indipendenza",
      "name": "Rapisardi, San Leone, Corso Indipendenza",
      "primary": true,
      "skipSearch": false
    }],
    "de-gasperi-p-zza-europa": [{
      "hkey": "c30088b9",
      "slug": "cannizzaro-ognina-lungomare-teseo",
      "name": "Cannizzaro, Ognina-Lungomare, Teseo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f9914c11": [{
      "hkey": "2d8b5f5f",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "rapirdi-san-leone-corso-indipendenza": [{
      "hkey": "df825c52",
      "slug": "rapisardi-san-leone-corso-indipendenza",
      "name": "Rapisardi, San Leone, Corso Indipendenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "via-etnea-via-umberto": [{
      "hkey": "2d8b5f5f",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "viale-m-rapisardi-lavaggi": [{
      "hkey": "df825c52",
      "slug": "rapisardi-san-leone-corso-indipendenza",
      "name": "Rapisardi, San Leone, Corso Indipendenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "via-leucatia-via-del-bosco": [{
      "hkey": "17a4f1d8",
      "slug": "barriera-canalicchio",
      "name": "Barriera, Canalicchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "via-palermo-nesima": [{
      "hkey": "df825c52",
      "slug": "rapisardi-san-leone-corso-indipendenza",
      "name": "Rapisardi, San Leone, Corso Indipendenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "via-p-nicola-picanello": [{
      "hkey": "9df6cb01",
      "slug": "picanello",
      "name": "Picanello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "via-s-euplio-s-m-gesu": [{
      "hkey": "2d8b5f5f",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zona-centro": [{
      "hkey": "2d8b5f5f",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zona-di-prestigio": [{
      "hkey": "01c9a0d6",
      "slug": "borgo-corso-province-viale-veneto",
      "name": "Borgo, Corso Province-Viale Veneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zona-periferica": [{
      "hkey": "4a123ae9",
      "slug": "librino-san-giorgio",
      "name": "Librino, San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zona-semicentro": [{
      "hkey": "64c2062e",
      "slug": "cibali-san-nullo-trappeto",
      "name": "Cibali, San Nullo, Trappeto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;